export default __webpack_public_path__ + "static/black-e31aa47ca2c8df9eaae84972d8c9755e.png";